import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as toolbarValidations from '../../Toolbar/ToolbarValidations';
import * as toolbarActions from '../../../redux/actions/ToolbarActions';
import * as multiWallHandler from '../../../redux/actions/multiWallHandler';
// import { handleZoomIn, handleZoomOut } from '../../../redux/canvasZoomActions';
// import { getActiveCanvas } from '../../../utilities/HelperFunctions/HelperFunctions';
import {
  checkIfCanvasApp,
  checkIfStickersTypeApp
} from '../../../redux/homeActions';
import './BottomToolBar.scss';
import { isToolbarItemDisabled } from '../../../utilities/HelperFunctions/HelperFunctions';
import * as Constants from '../../../utilities/constants/Constants';

import Group from '../../../utilities/Icons/Toolbar/Regular/version2/group.svg';
import GroupDisabled from '../../../utilities/Icons/Toolbar/Regular/version2/group_disabled.svg';
import Ungroup from '../../../utilities/Icons/Toolbar/Regular/version2/ungroup.svg';
import UngroupDisabled from '../../../utilities/Icons/Toolbar/Regular/version2/ungroup_disabled.svg';

const BottomToolBar = props => {
  // const [scaleValue, setScaleValue] = useState(0);

  const {
    activeObject,
    viewType,
    wallCanvas,
    projectCategory,
    partnerStoreType,
    dispatchers
  } = props;

  const isCanvas = dispatchers.checkIfCanvasApp();
  const isSticker = dispatchers.checkIfStickersTypeApp();
  const isSharedScene = dispatchers.multiWallHandler.isSharedScene();
  const hasMultiwalls =
    dispatchers.multiWallHandler.hasLeftMultiWallProjects() ||
    dispatchers.multiWallHandler.hasRightMultiWallProjects();

  const validationMethodsArguments = [
    viewType,
    isCanvas,
    activeObject,
    wallCanvas,
    projectCategory,
    partnerStoreType,
    hasMultiwalls,
    isSharedScene,
    isSticker
  ];

  // const mounted = useRef();

  // useEffect(() => {
  //   if (!mounted.current) {
  //     mounted.current = true;
  //   } else {
  //     scaleIsClicked(scaleValue);
  //   }
  // }, [scaleValue]);

  // const scaleIsClicked = value => {
  //   const val = parseFloat(value).toFixed(2);
  //   dispatchers.toolbarActions.scaleCanvas(val, activeObject, wallCanvas);
  // };

  // const setScaleRangeValue = e => {
  //   let value = 0;
  //   value = parseFloat(e.target.value).toFixed(2);
  //   setScaleValue(value);
  // };

  // const enableScaleToFill = toolbarValidations.canAddScaleToFillTool(
  //   ...validationMethodsArguments
  // );

  const showGroupAll = toolbarValidations.canAddGroupTool(
    ...validationMethodsArguments
  );
  const showUngroupAll = toolbarValidations.canAddUngroupTool(
    ...validationMethodsArguments
  );

  const disableGroupAll = dispatchers.isToolbarItemDisabled(
    Constants.GROUP_ALL_TOOL
  );
  const disableUngroupAll = dispatchers.isToolbarItemDisabled(
    Constants.UNGROUP_TOOL
  );

  return (
    <div className='bottom-toolbar-container' id='bottom-bar'>
      {/*  <Slider
        min={0}
        max={100}
        className='mr-4'
        value={scaleValue}
        onChange={setScaleRangeValue}
      />  */}

      <div>
        {/* {enableScaleToFill && (
          <button
            className='border-0'
            type='button'
            disabled={!enableScaleToFill}
            onClick={() => {
              dispatchers.toolbarActions.scaleToFillAction(
                activeObject,
                wallCanvas
              );
            }}
          >
            <img alt='' src={Icons.expand} />
          </button>
        )} */}
        {showGroupAll && (
          <button
            type='button'
            className='border-0'
            disabled={disableGroupAll}
            onClick={() => dispatchers.toolbarActions.groupAction()}
          >
            <img alt='' src={disableGroupAll ? GroupDisabled : Group} />
          </button>
        )}
        {showUngroupAll && (
          <button
            type='button'
            className='border-0'
            disabled={disableUngroupAll}
            onClick={() => dispatchers.toolbarActions.ungroupAction()}
          >
            <img alt='' src={disableUngroupAll ? UngroupDisabled : Ungroup} />
          </button>
        )}
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    wallCanvas: state.fabricCanvas.wallCanvas,
    activeObject: state.fabricCanvas.activeObject,
    projectCategory: state.modal.envData.category,
    partnerStoreType: state.modal.storeData.partnerStoreType,
    viewType: state.fabricCanvas.viewType,
    triggerProjectDirty: state.fabricCanvas.triggerProjectDirty
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      multiWallHandler: bindActionCreators(multiWallHandler, dispatch),
      toolbarActions: bindActionCreators(toolbarActions, dispatch),
      // handleZoomIn: bindActionCreators(handleZoomIn, dispatch),
      // handleZoomOut: bindActionCreators(handleZoomOut, dispatch),
      checkIfCanvasApp: bindActionCreators(checkIfCanvasApp, dispatch),
      checkIfStickersTypeApp: bindActionCreators(
        checkIfStickersTypeApp,
        dispatch
      ),
      isToolbarItemDisabled: bindActionCreators(isToolbarItemDisabled, dispatch)

      // getActiveCanvas: bindActionCreators(getActiveCanvas, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BottomToolBar);
